import { Component, OnInit, ViewChild } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { ProposalService } from 'src/app/services/proposal.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { CreateProposalDTO } from 'src/app/models/createproposaldto';
import { Proposal } from 'src/app/models/proposal';
import cloneDeep from 'lodash/cloneDeep';
import { UpdateProposalStatusDTO } from 'src/app/models/internal/updateproposalstatusdto';
import { Constants } from 'src/app/core/constants';
import { ProposalImage } from 'src/app/models/proposal-image';
import { RejectionReason } from 'src/app/models/rejection-reason';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MultiSelectItem } from '@tesla/angular2-tesla-common/tesla-common';
import { Observable } from 'rxjs';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { AppGlobalDataService } from 'src/app/services/appglobaldata.service';
import { FormService } from 'src/app/services/form';
import { template } from '@angular/core/src/render3';
import { PackageLevelTemplate } from 'src/app/models/packageleveltemplate';
import { ProposalDetailsComponent } from '../../proposal-details/proposal-details.component';
import { ProposalDocument } from 'src/app/models/proposal-document';
import { ProposalInternalComment } from 'src/app/models/proposal-internal-comment';
import { ProposalInternalCommentComponent } from '../../proposal-internal-comment/proposal-internal-comment.component';
import { UpdateProposalCommentDTO } from 'src/app/models/internal/update-proposal-comment-dto';
import { AppSettings } from 'src/app/app.settings';
import { BasePage } from 'src/app/core/basepages/allbasepages';
import Helper from 'src/app/core/utility/helper';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'app-proposal-snapshot',
    templateUrl: './proposal-snapshot.component.html',
    styleUrls: ['./proposal-snapshot.component.scss'],
})
export class ProposalSnapshotComponent extends BasePage implements OnInit {
    isCriticalPart: boolean;
    pageName: string = 'reviewproposal';
    ShowServiceOptimizedOption: boolean = false;
    ServiceOptimizedOptionRequired: boolean = false;
    ShowEffectiveToWarningMessage: boolean = false;
    childControlTooltipText: string = '';
    appSettings: AppSettings;
    rejectionInfo = [];
    IsEmployee: boolean;
    IsSupplier: boolean;
    IsEmployee$: Observable<boolean>;
    IsSupplier$: Observable<boolean>;
    proposalId: string;    
    proposalDTO: Proposal;
    updateProposalStatusDTO = new UpdateProposalStatusDTO();
    partImages: ProposalImage[] = [];
    packageImages: ProposalImage[] = [];
    packageDocuments: ProposalDocument[] = [];
    rejectionReasonsList: RejectionReason[];
    serviceOptimizedOptionsList: any[] = [];
    serviceSourceTypeIdList: number[];
    public formErrors = {
        RejectionReason: '',
        RejectionComment: '',
        IsServiceOptimized: '',
        IsConditionallyApproved: '',
        ConditionalApproveComment: '',
        EffectiveTo: '',

    };
    public proposalCommentFormErrors = {
        ProposalComment: '',
    };
    OkToApprove = true;
    OkToReject = true;
    OKToShowConditionallyApproveFields = false;
    RejectReasonNotSelected = false;
    RejectionCommentRequired = false;
    reviewProposalForm: FormGroup;
    adhocChargebackForm: FormGroup;
    internalCommentsForm: FormGroup;
    proposalCommentForm: FormGroup;
    selectedReasons: MultiSelectItem[] = [];
    otherRejectionReasonSelected: boolean = false;
    primaryPackageLevelTemplateId: number;
    primaryPackageLevelTemplate: any;
    secondaryPackageLevelTemplateId: number;
    secondaryPackageLevelTemplate: any;
    tertiaryPackageLevelTemplateId: number;
    tertiaryPackageLevelTemplate: any;
    allLevelPackageTemplates: any[];
    proposalEstimateId: string = null;
    @ViewChild(ProposalDetailsComponent)
    proposalDetailsComponent: ProposalDetailsComponent;
    @ViewChild(ProposalInternalCommentComponent)
    proposalInternalCommentComponent: ProposalInternalCommentComponent;
    formSubmitted = false;
    rejectionComment = [];
    IsConditionalApprovalTrue: boolean = false;


    constructor(
        private dataService: DataService,
        private proposalService: ProposalService,
        private router: Router,
        private toastService: ToastService,
        localstorageService: LocalstorageService,
        public FormService: FormService,
        private appGlobalDataService: AppGlobalDataService,
        private fb: FormBuilder,
        logger: NGXLogger,
        appSettings: AppSettings,
            private readonly route: ActivatedRoute
    ) {
        super(localstorageService, logger, appSettings);
        this.adhocChargebackForm = this.fb.group({
            ChargebackReason: [null],
            Amount: [null]
        });
        this.reviewProposalForm = this.fb.group({
            RejectReasonIds: [null],
            RejectionComment: [null],
            IncompleteComments: [null],
            PendingValidationComments: [null],
            DoesAdhereGuidelines: [false],
            DoesSupportInPlantHandling: [false],
            DoesFitLineside: [false],
            IsServiceOptimized: [null],
            IsConditionallyApproved: false,
            ConditionalApproveComment: [null],
            EffectiveTo: [null],
            ApproveCommentForLowUtilization: [null],
        });
        this.proposalCommentForm = this.fb.group({
            ProposalComment: [null],
        });
        this.appSettings = appSettings;
        this.serviceOptimizedOptionsList.push({'Description': "Yes", 'Id': 1});
        this.serviceOptimizedOptionsList.push({'Description': "No", 'Id': 0});
    }

    ngOnInit() {
        // this.proposalService.proposalToReviewId.subscribe(id => {
        //   this.getProposal(id);
        // })
        this.route.paramMap.subscribe(params => {
            this.proposalId = params.get('id');
            if (this.proposalId) {
                this.getProposal(this.proposalId);
            }
        });
        this.getRejectionReasons();
        this.getServiceSourceTypes();
        this.setFlags();
    }

    getDynamic_box(): any {
        let result = 0;
        if (
            this.primaryPackageLevelTemplate &&
            this.primaryPackageLevelTemplate.length > 0
        ) {
            const template = this.primaryPackageLevelTemplate[0];
            const aConstant = 5.87;
            const AvgVibrationFactor = 0.67;
            const fluteSizeNumber = this.getfluteSizeNumber(template.FluteSize);
            const burstStrengthNumber = this.getBurstStrengthNumber(
                template.BurstStrength
            );
            result =
                Math.round(
                    aConstant *
                        burstStrengthNumber *
                        Math.sqrt(
                            fluteSizeNumber *
                                (2 * template.ODLength + 2 * template.ODWidth)
                        ) *
                        AvgVibrationFactor *
                        10000
                ) / 10000;
        }
        if (Number.isNaN(result)) {
            return Constants.ERROR_STACKABILITY_MISSING_INPUT;
        } else {
            return result;
        }
    }

    getDynamic_Layer(): any {
        if (
            !this.proposalDTO.PackageInfo.ProposalPackageLevels ||
            this.proposalDTO.PackageInfo.ProposalPackageLevels.length < 2
        ) {
            return 0;
        }
        const dynamicBox = this.getDynamic_box();
        let result = 0;
        if (dynamicBox && dynamicBox != 0 && !Number.isNaN(dynamicBox)) {
            if (this.proposalDTO && this.proposalDTO.PackageInfo) {
                const noOfContainers = this.proposalDTO.PackageInfo
                    .ProposalPackageLevels[1].ContainersPerLayer;
                result =
                    Math.round(dynamicBox * noOfContainers * 10000) / 10000;
            }
        }
        if (Number.isNaN(result)) {
            return Constants.ERROR_STACKABILITY_MISSING_INPUT;
        } else {
            return result;
        }
    }
    getDynamic_UnitLoad() {
        const result = 0;
        const dynamicLayer = this.getDynamic_Layer();
        const totalWeight = this.getSecondaryTotalWeight();
        if (
            dynamicLayer &&
            dynamicLayer != 0 &&
            !Number.isNaN(dynamicLayer) &&
            totalWeight != 0
        ) {
            return Math.round((dynamicLayer / totalWeight) * 10) / 10;
        }
        if (Number.isNaN(result)) {
            return Constants.ERROR_STACKABILITY_MISSING_INPUT;
        } else {
            return result;
        }
    }

    getSecondaryTotalWeight() {
        if (
            !this.proposalDTO.PackageInfo.ProposalPackageLevels ||
            this.proposalDTO.PackageInfo.ProposalPackageLevels.length < 2
        ) {
            return 0;
        }
        if (this.proposalDTO && this.proposalDTO.PackageInfo) {
            const pLevel = this.proposalDTO.PackageInfo
                .ProposalPackageLevels[0];
            const sLevel = this.proposalDTO.PackageInfo
                .ProposalPackageLevels[1];
            const pWeight =
                pLevel.TareWeight +
                this.proposalDTO.PartInfo.Weight * pLevel.QPC;
            return (
                pWeight * sLevel.ContainersPerLayer * sLevel.NoOfLayers +
                sLevel.TareWeight
            );
        }
    }
    SetServiceOptimizedOptionFlag() {
        if (this.proposalDTO && this.proposalDTO.PackageInfo) {
          var propSourceTypeIds = this.proposalDTO.PackageInfo.SourceTypes.map(x => x.SourceTypeId);
          if (propSourceTypeIds === undefined || propSourceTypeIds.length == 0) 
          {
            return;
          }
          // check if any prop source type is a service sourcetype
          propSourceTypeIds.forEach(x => {
            if(this.serviceSourceTypeIdList.includes(x))
            {
                this.ShowServiceOptimizedOption = true;
            }
          })
        } 
      }
    getProposal(id: string) {
        this.dataService.getProposal(id).subscribe((response: any) => {
            if (response && response.Data != null) {
                const fullProposalDTO = new CreateProposalDTO();
                this.proposalDTO = cloneDeep(response.Data);
                if (this.proposalDTO.PackageInfo.RejectionReason && this.proposalDTO.PackageInfo.RejectionReason.length > 0) {
                    this.rejectionInfo = Helper.fillRejectionInfo(this.proposalDTO);
                }
                this.rejectionComment = Helper.getListRejectionComment(this.proposalDTO.PackageInfo.RejectionComment);
                this.proposalCommentForm.controls['ProposalComment'].setValue(this.proposalDTO.PackageInfo.Comment);
                this.reviewProposalForm.controls['IncompleteComments'].setValue(this.proposalDTO.IncompleteComments);
                this.reviewProposalForm.controls['PendingValidationComments'].setValue(this.proposalDTO.PendingValidationComments);
                if(this.proposalDTO.PartInfo.Parts[0].ProposalEstimateId > 0)
                    this.proposalEstimateId = this.proposalDTO.PartInfo.Parts[0].ProposalEstimateId + "";

                const ids: number[] = [];
                this.IsConditionalApprovalTrue = this.proposalDTO.PackageInfo['IsConditionalApproval'];
                this.primaryPackageLevelTemplateId = this.getPackagelevelTemplateId(0);
                this.secondaryPackageLevelTemplateId = this.getPackagelevelTemplateId(1);
                this.tertiaryPackageLevelTemplateId = this.getPackagelevelTemplateId(2);
                if (this.primaryPackageLevelTemplateId) {
                    ids.push(this.primaryPackageLevelTemplateId);
                }
                if (this.secondaryPackageLevelTemplateId) {
                    ids.push(this.secondaryPackageLevelTemplateId);
                }
                if (this.tertiaryPackageLevelTemplateId) {
                    ids.push(this.tertiaryPackageLevelTemplateId);
                }
                if (ids && ids.length > 0) {
                    this.dataService
                        .getPackageTemplateByIds(ids)
                        .subscribe((templates: any) => {
                            if (templates && templates.Data.length > 0) {
                                this.allLevelPackageTemplates = templates.Data;
                                this.primaryPackageLevelTemplate = this.allLevelPackageTemplates.filter(
                                    x =>
                                        x.Id ===
                                        this.primaryPackageLevelTemplateId
                                );
                                this.secondaryPackageLevelTemplate = this.allLevelPackageTemplates.filter(
                                    x =>
                                        x.Id ===
                                        this.secondaryPackageLevelTemplateId
                                );
                            }
                        });
                }

                if (
                    this.proposalDTO.ImageInfo &&
                    this.proposalDTO.ImageInfo.length > 0
                ) {
                    this.partImages = this.proposalDTO.ImageInfo.filter(
                        a => a.Type == 1
                    );
                    this.packageImages = this.proposalDTO.ImageInfo.filter(
                        a => a.Type == 2
                    );
                }
                if (
                    this.proposalDTO.DocumentInfo &&
                    this.proposalDTO.DocumentInfo.length > 0
                ) {
                    this.packageDocuments = this.proposalDTO.DocumentInfo;
                }
            }
            this.SetServiceOptimizedOptionFlag();

        });
    }

    getPackagelevelTemplateId(levelIndex: number) {
        if (
            !this.proposalDTO ||
            !this.proposalDTO.PackageInfo ||
            !this.proposalDTO.PackageInfo.ProposalPackageLevels
        ) {
            return 0;
        }
        if (this.proposalDTO.PackageInfo.ProposalPackageLevels[levelIndex]) {
            return this.proposalDTO.PackageInfo.ProposalPackageLevels[
                levelIndex
            ].PackagelevelTemplateId;
        } else {
            return 0;
        }
    }

    getfluteSizeNumber(fluteSize: string) {
        if (fluteSize) {
            fluteSize = fluteSize.trim();
            fluteSize = fluteSize.replace(' ', '');
            fluteSize = fluteSize.toUpperCase();
            switch (fluteSize) {
                case 'A': {
                    return 0.2;
                    break;
                }
                case 'B': {
                    return 0.117;
                    break;
                }
                case 'C': {
                    return 0.159;
                    break;
                }
                case 'AB': {
                    return 0.305;
                    break;
                }
                case 'AC': {
                    return 0.347;
                    break;
                }
                case 'BC': {
                    return 0.264;
                    break;
                }
                case 'CAA': {
                    return 0.25;
                    break;
                }
                default: {
                    return 0.25;
                    break;
                }
            }
        }
    }
    saveProposalComment() {
        this.ValidateProposalCommentForm();
        if (this.proposalCommentForm.valid) {
            const comment: UpdateProposalCommentDTO = new UpdateProposalCommentDTO();
            comment.ProposalId = +this.proposalId;
            comment.Comment = this.proposalCommentForm.get(
                'ProposalComment'
            ).value;
            this.logDebug('saving proposal comment', comment);
            this.dataService.updateProposalComment(comment).subscribe(data => {
                // this.partInfo = data
                if (data != null) {
                    this.toastService.success(
                        'Proposal comment ' + Constants.SUCCESS_SAVE_GENERIC
                    );
                }
            });
        }
    }

    getBurstStrengthNumber(burstStrength: string) {
        if (burstStrength) {
            burstStrength = burstStrength.trim();
            burstStrength = burstStrength.replace(' ', '');
            switch (burstStrength) {
                case '275#': {
                    return 44;
                    break;
                }
                default: {
                    return 1;
                    break;
                }
            }
        }
    }

    getRejectionReasons() {
        this.dataService.getRejectionReasons().subscribe((response: any) => {
            // this.partInfo = data
            if (response && response.Data != null) {
                this.rejectionReasonsList = response.Data;
            }
        });
    }
    
    getServiceSourceTypes() {
        this.dataService.getServiceSourceTypes().subscribe((response: any) => {
            // this.partInfo = data
            if (response != null) {
                this.serviceSourceTypeIdList = response;
            }
        });
    }
    
    RejectionReasonChanged(rejectionReasonIds: number[]) {
        this.RejectReasonNotSelected = false;
        // let otherReasonItem = this.rejectionReasonsList.filter(a => a.Description.toUpperCase() == 'OTHER');
        // if(otherReasonItem)
        // {
        //     this.otherRejectionReasonSelected = rejectionReasonIds.includes(otherReasonItem[0].Id);
        // }
        if (rejectionReasonIds.length > 0) {
            this.OkToApprove = true;
            this.OkToReject = false;
        } else {
            this.OkToApprove = true;
            this.OkToReject = true;
        }
        if (
            this.reviewProposalForm.controls['DoesAdhereGuidelines'].value ||
            this.reviewProposalForm.controls['DoesSupportInPlantHandling']
                .value ||
            this.reviewProposalForm.controls['DoesFitLineside'].value
        ) {
            this.OkToApprove = true;
            this.OkToReject = true;
        }
        if (
            this.reviewProposalForm.controls['DoesAdhereGuidelines'].value &&
            this.reviewProposalForm.controls['DoesSupportInPlantHandling']
                .value &&
            this.reviewProposalForm.controls['DoesFitLineside'].value &&
            rejectionReasonIds.length == 0
        ) {
            this.OkToApprove = false;
            this.OkToReject = true;
        }
    }

    PendingValidationProposals() {
        this.prepareModel(Constants.WORKFLOW_STATUS_PENDINGVALIDATION);
        this.updateProposalStatus();
    }

    IncompleteProposals() {
        this.prepareModel(Constants.WORKFLOW_STATUS_INCOMPLETE);
        this.updateProposalStatus();
    }

    getSelectedActionIndex() {
        switch(this.proposalDTO.PackageInfo.WorkflowStatusId){
            case Constants.WORKFLOW_STATUS_INCOMPLETE: 
            return 2;
            case Constants.WORKFLOW_STATUS_PENDINGVALIDATION: 
            return 1;
            case Constants.WORKFLOW_STATUS_REJECTED: 
            return 3;
        }
        return 0;
    }

    issueChargeback() {
        var amount = this.adhocChargebackForm.controls['Amount'].value;
        var reason = this.adhocChargebackForm.controls['ChargebackReason'].value;
        var part = this.proposalDTO.PartInfo.Parts[0];
        
        if(amount % 100 != 0) {
            this.toastService.error("Chargeback amount must be in multiples of 100");
            return; 
        }

        var dto = {
            amount: amount,
            comment: reason,
            sourceTypeId: part.SourceTypeId,
            partNumber: part.PartNumber,
            supplierCode: part.SupplierCode
        }
        
        // this is commented since for is hidden until future grooming
        // this.dataService.postAdhocChargeback(dto).subscribe((data)=> {
        //     this.toastService.success("Chargeback posted");
        // });
        return;
    }

    RejectProposals() {

        if(!this.IsServiceOptimizedSelected())
        {
            return;
        }
        if (!this.reviewProposalForm.controls['RejectReasonIds'].value) {
            this.RejectReasonNotSelected = true;
            return;
        }
        const rejectionComment = this.reviewProposalForm.controls[
            'RejectionComment'
        ].value;
        if (
            this.reviewProposalForm.controls['RejectReasonIds'].value &&
            !rejectionComment
        ) {
            this.RejectionCommentRequired = true;
            return;
        } else {
            this.RejectionCommentRequired = false;
        }
        this.updateProposalStatusDTO.UserBypassedActiveProposalWarning = false;
        if (this.proposalDTO.IsLatestActiveProposal){
            if(!confirm("This is the latest active proposal for this part number. Rejecting the proposal would mean that we will not have any valid packaging proposal for MRP or TMS to use for FOQ selection and shipment optimization. If the dimension, weight and QPC are correct but you want the supplier to update some other information, then you can mark it 'Incomplete', so that it will show up in supplier's queue and they can fix it. Supplier will also get chargeback if they do not comply. Do you still want to reject the proposal?")){
                return; 
            } else {
                this.updateProposalStatusDTO.UserBypassedActiveProposalWarning = true;
            }
        }
        this.ValidateForm();
        if (this.reviewProposalForm.valid) {
            this.prepareModel(Constants.WORKFLOW_STATUS_REJECTED);
            // this.updateProposalStatusDTO.WorkflowStatusId =
            //     Constants.WORKFLOW_STATUS_REJECTED;
            // this.updateProposalStatusDTO.ProposalId = [+this.proposalId];
            let temp = 1;
            this.updateProposalStatusDTO.RejectReasonIds.forEach(x => {
                if (temp == 1) {
                    if (
                        this.rejectionReasonsList.find(a => a.Id == x)
                            .IsNonCompliant
                    ) {
                        this.updateProposalStatusDTO.MRPSolverFlag = true;
                    } else {
                        this.updateProposalStatusDTO.MRPSolverFlag = false;
                        temp = 0;
                    }
                }
            });
            this.updateProposalStatus();
        }
    }
    ApproveProposals() {
        if (this.reviewProposalForm.controls['EffectiveTo'].value != null && !this.ValidateEffectiveToDate()) {
            return;
        }
        if(!this.IsServiceOptimizedSelected())
        {
            return;
        }
        this.prepareModel(Constants.WORKFLOW_STATUS_APPROVED);
        // this.updateProposalStatusDTO.WorkflowStatusId =
        //     Constants.WORKFLOW_STATUS_APPROVED;
        // this.updateProposalStatusDTO.RejectionComment = this.reviewProposalForm.controls['RejectionComment'].value;
        if (
            !this.reviewProposalForm.controls['IsConditionallyApproved'].value
        ) {
            this.updateProposalStatusDTO.EffectivityTo = this.proposalDTO.PackageInfo.ProposalEffectivity.EffectiveTo;
        }
        this.updateProposalStatusDTO.ApproveCommentForLowUtilization =
            this.reviewProposalForm.controls[
                'ApproveCommentForLowUtilization'
            ].value;
        this.updateProposalStatusDTO.MRPSolverFlag = true;
        this.updateProposalStatus();
    }
    prepareModel(worflowStatusId: number) {
        this.updateProposalStatusDTO.WorkflowStatusId = worflowStatusId;
        this.updateProposalStatusDTO.IsServiceOptimized = this.reviewProposalForm.controls[
            'IsServiceOptimized'
        ].value;;
        this.updateProposalStatusDTO.ProposalId = +this.proposalId;
        this.updateProposalStatusDTO.RejectReasonIds = this.reviewProposalForm.controls[
            'RejectReasonIds'
        ].value;
        this.updateProposalStatusDTO.RejectionComment = this.reviewProposalForm.controls[
            'RejectionComment'
        ].value;

        this.updateProposalStatusDTO.PendingValidationComments = this.reviewProposalForm.controls[
            'PendingValidationComments'
        ].value;

        this.updateProposalStatusDTO.IncompleteComments = this.reviewProposalForm.controls[
            'IncompleteComments'
        ].value;

        this.updateProposalStatusDTO.IsConditionalApproval = this.reviewProposalForm.controls['IsConditionallyApproved'].value;
        this.updateProposalStatusDTO.ConditionalApprovalMessage = this.reviewProposalForm.controls['ConditionalApproveComment'].value;
        this.updateProposalStatusDTO.EffectivityTo = this.reviewProposalForm.controls['EffectiveTo'].value;
    }
    updateProposalStatus() {
        this.formSubmitted = true;
        this.scrollToTop();
        this.dataService
            .updateProposalsStatus(this.updateProposalStatusDTO)
            .subscribe(data => {
                // this.partInfo = data
                if (data != null) {
                    this.toastService.success(
                        'Proposal Status ' + Constants.SUCCESS_SAVE_GENERIC
                    );
                }
            });
    }
    ApprovalCheckboxClicked() {
        if (
            this.reviewProposalForm.controls &&
            this.reviewProposalForm.controls['DoesAdhereGuidelines'].value &&
            this.reviewProposalForm.controls['DoesSupportInPlantHandling']
                .value &&
            this.reviewProposalForm.controls['DoesFitLineside'].value
        ) {
            this.OkToApprove = false;
            this.OkToReject = true;
        } else {
            this.OkToApprove = true;
            this.OkToReject = true;
        }
        if (
            this.reviewProposalForm.controls['RejectReasonIds'].value != null &&
            this.reviewProposalForm.controls['RejectReasonIds'].value.length >
                0 &&
            !this.reviewProposalForm.controls['DoesAdhereGuidelines'].value &&
            !this.reviewProposalForm.controls['DoesSupportInPlantHandling']
                .value &&
            !this.reviewProposalForm.controls['DoesFitLineside'].value
        ) {
            this.OkToReject = false;
        }
        if (
            this.reviewProposalForm.controls['RejectReasonIds'].value != null &&
            this.reviewProposalForm.controls['RejectReasonIds'].value.length >
                0 &&
            !this.OkToApprove
        ) {
            this.OkToApprove = true;
        }
    }
    getImageURL(image: ProposalImage) {
        // this.logDebug(image.Url + 'contains version = ' + image.Url.includes("/version/"));
        return (
            this.appSettings.WarpStorageAPIImageBaseUrl +
            '/' +
            this.proposalId +
            '/file/' +
            image.UUId
        );
    }

    ValidateForm() {
        this.formErrors = this.FormService.validateForm(
            <FormGroup>this.reviewProposalForm,
            this.formErrors
        );
    }

    ValidateProposalCommentForm() {
        this.proposalCommentFormErrors = this.FormService.validateForm(
            <FormGroup>this.proposalCommentForm,
            this.proposalCommentFormErrors
        );
    }
    closeWindow() {
        window.opener.location.reload(true);
        window.close();
    }
    getStackability() {
        if (this.proposalDetailsComponent) {
            return this.proposalDetailsComponent.getStackability();
        } else {
            return false;
        }
    }

    // function to check if service optimized flag is set (only if it's relevant i.e. only if service type sourcetype)
    IsServiceOptimizedSelected() : boolean {
        this.ServiceOptimizedOptionRequired = false;
        if(!this.ShowServiceOptimizedOption)
        {
            return true;
        }
        const isServiceOptimizedValue = this.reviewProposalForm.get('IsServiceOptimized').value;
        if (isServiceOptimizedValue == null) {
            // set error display field visibility
            this.ServiceOptimizedOptionRequired = true;
                return false;
        }
        else
        {
            return true;
        }
    }

    //tms-36311 validate effective to date
    ValidateEffectiveToDate(): boolean {
        this.ShowEffectiveToWarningMessage = false;
        const effectiveTo = new Date(this.reviewProposalForm.controls['EffectiveTo'].value);
        const effectiveFrom = new Date(this.proposalDTO.PackageInfo.ProposalEffectivity.EffectiveFrom);

        if (effectiveTo <= effectiveFrom) {
            this.ShowEffectiveToWarningMessage = true;
            return false;
        }
        else {
            return true;
        }
    }
    refreshToolTipText(code: string) {
        this.childControlTooltipText = Constants[code];
    }

    IsConditionallyApprovedCLicked(): boolean {
        this.OKToShowConditionallyApproveFields = this.reviewProposalForm.controls['IsConditionallyApproved'].value != null && this.reviewProposalForm.controls['IsConditionallyApproved'].value == true ? true : false;
        return this.OKToShowConditionallyApproveFields;
    }

    proposalLoaded(proposal) {
        this.isCriticalPart = proposal && proposal.PartInfo && proposal.PartInfo.Parts && proposal.PartInfo.Parts[0].IsCriticalPart;
      }

}
